import { createUseStyles } from 'react-jss';

const styles = createUseStyles(() => ({
  appDetailsHeader: {
    backgroundColor: '#DAEAE4',
  },
  appDetailsHeaderLogo: {
    borderRadius: '5px',
    backgroundColor: 'white',
    boxShadow: '0px 1px 2px grey',
    img: {
      maxWidth: '300px',
    },
  },
  appDetailsMediaGallery: {
    maxHeight: '150px',
  },
}));

export default styles;
